import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './App.css';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

function App() {
  const [currentSection, setCurrentSection] = useState(0);
  const [state, handleSubmit] = useForm("xnjpdoez");
  
  // 0 = Home, 1 = About Us, 2 = Portfolio, 3 = Contacts
  const navigateToSection = (sectionIndex) => {
    setCurrentSection(sectionIndex);
  };

  return (
    <div className="App">
      {/* Sliding Container */}
      <div 
        className="slider-container" 
        style={{ transform: `translateX(-${currentSection * 100}vw)` }}
      >
        {/* Hero Section */}
        <section className="hero slide" id="home">
          <div className="hero-content">
            {/* Logo Placeholder */}
            <div className="company-logo">
              {/* Add your logo image here */}
              <img src="/13637c7a38ecc2d0674901c12375b614.jpg" alt="Fumagalli & Co Logo" className="logo-image" />
            </div>
            
            <h1 className="company-name">Fumagalli & Co</h1>
            <h2 className="company-subtitle">Intelligence Technology</h2>
            
            {/* Bottom Navbar */}
            <nav className="bottom-navbar">
              <div className="navbar-icon">
                <LanguageOutlinedIcon sx={{ fontSize: 32, color: '#ffffff' }} />
              </div>
              <div className="navbar-links">
                <button onClick={() => navigateToSection(1)} className="navbar-link">About Us</button>
                <button onClick={() => navigateToSection(2)} className="navbar-link">Portfolio</button>
                <button onClick={() => navigateToSection(3)} className="navbar-link">Contacts</button>
              </div>
              <div className="navbar-cta">
                <button onClick={() => navigateToSection(3)} className="navbar-cta-button">Get In Touch</button>
              </div>
            </nav>
          </div>
        </section>

        {/* About Us Section */}
        <section className="about-section slide" id="about">
          <div className="about-container">
            
            {/* Left Column - Narrative */}
            <div className="about-narrative">
              <h2 className="about-title">About Us</h2>
              
              <div className="about-text">
                <p className="about-intro">
                  A vision split in two directions
                </p>
                
                <p className="about-paragraph">
                  Fumagalli & Co Intelligence Technology bridges tradition and innovation. 
                  Rooted in the values of family business—integrity, dedication, and personal 
                  attention—we embrace the transformative power of modern technology.
                </p>
                
                <p className="about-paragraph">
                  Our approach is both respectful of established practices and boldly forward-thinking. 
                  We understand that the future demands more than technical expertise; it requires a 
                  strategic eye, an understanding of human needs, and a commitment to building tools 
                  that enhance rather than replace.
                </p>
                
                <p className="about-paragraph">
                  From legal professionals to educators, from enterprises to individuals, we craft 
                  intelligent solutions that honor the past while embracing the possibilities of tomorrow.
                </p>
              </div>

              {/* Back button */}
              <button onClick={() => navigateToSection(0)} className="back-button about-back-button">
                ← Back to Home
              </button>
            </div>

            {/* Right Column - Values Tree */}
            <div className="values-tree">
              <div className="tree-line"></div>
              
              <div className="value-node" style={{ top: '0%' }}>
                <div className="node-dot"></div>
                <div className="node-content">
                  <div className="node-title">Client Attention</div>
                  <div className="node-description">
                    Personal dedication to understanding and meeting your unique needs
                  </div>
                </div>
              </div>

              <div className="value-node" style={{ top: '25%' }}>
                <div className="node-dot"></div>
                <div className="node-content">
                  <div className="node-title">Privacy</div>
                  <div className="node-description">
                    Unwavering commitment to data protection and confidentiality
                  </div>
                </div>
              </div>

              <div className="value-node" style={{ top: '50%' }}>
                <div className="node-dot"></div>
                <div className="node-content">
                  <div className="node-title">Professionalism</div>
                  <div className="node-description">
                    Excellence in execution, from conception to delivery
                  </div>
                </div>
              </div>

              <div className="value-node" style={{ top: '75%' }}>
                <div className="node-dot"></div>
                <div className="node-content">
                  <div className="node-title">Tradition</div>
                  <div className="node-description">
                    Built on family values and long-term relationships
                  </div>
                </div>
              </div>

              <div className="value-node" style={{ top: '100%' }}>
                <div className="node-dot"></div>
                <div className="node-content">
                  <div className="node-title">Innovation</div>
                  <div className="node-description">
                    Strategic vision for emerging technologies and future needs
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Portfolio Section - Placeholder */}
        <section className="portfolio-section slide" id="portfolio">
          <div className="section-container">
            <h2 className="section-title">Portfolio</h2>
            <p className="section-subtitle">Coming Soon</p>
            <button onClick={() => navigateToSection(0)} className="back-button">
              ← Back to Home
            </button>
          </div>
        </section>

        {/* Contacts Section - Contact Form */}
        <section className="contacts-section slide" id="contacts">
          <div className="contact-content-wrapper">
            
            {/* Title Section */}
            <div className="contact-header">
              <h1 className="contact-main-title">Interested in our solutions?</h1>
              <h2 className="contact-sub-title">Let's talk</h2>
            </div>

            {/* Form */}
            <div className="contact-form-container">
              {state.succeeded ? (
                <div className="success-message">
                  <h3>Thank you for reaching out! 🎉</h3>
                  <p>We've received your message and will get back to you within 24-48 hours.</p>
                  <button 
                    onClick={() => navigateToSection(0)} 
                    className="back-button"
                    style={{ marginTop: '20px' }}
                  >
                    ← Back to Home
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  
                  {/* Full Name */}
                  <div className="form-group">
                    <label className="form-label">Full Name *</label>
                    <input
                      type="text"
                      name="fullName"
                      required
                      placeholder="Your name"
                      className="form-input"
                    />
                    <ValidationError 
                      prefix="Full Name" 
                      field="fullName"
                      errors={state.errors}
                    />
                  </div>

                  {/* Email */}
                  <div className="form-group">
                    <label className="form-label">Email *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="your@email.com"
                      className="form-input"
                    />
                    <ValidationError 
                      prefix="Email" 
                      field="email"
                      errors={state.errors}
                    />
                  </div>

                  {/* Company */}
                  <div className="form-group">
                    <label className="form-label">Company</label>
                    <input
                      type="text"
                      name="company"
                      placeholder="Your company"
                      className="form-input"
                    />
                  </div>

                  {/* Subject */}
                  <div className="form-group">
                    <label className="form-label">Subject *</label>
                    <select name="subject" required className="form-input">
                      <option value="">Select topic...</option>
                      <option value="soundslegal">SoundsLegal - Legal Tech</option>
                      <option value="thedrift">TheDrift - Interview Coaching</option>
                      <option value="cybersecurity">Cybersecurity Solutions</option>
                      <option value="partnership">Partnership Opportunities</option>
                      <option value="other">Other Inquiry</option>
                    </select>
                    <ValidationError 
                      prefix="Subject" 
                      field="subject"
                      errors={state.errors}
                    />
                  </div>

                  {/* Message */}
                  <div className="form-group">
                    <label className="form-label">Message *</label>
                    <textarea
                      name="message"
                      required
                      placeholder="Tell us about your project or inquiry..."
                      rows="5"
                      className="form-input form-textarea"
                    />
                    <ValidationError 
                      prefix="Message" 
                      field="message"
                      errors={state.errors}
                    />
                  </div>

                  {/* Submit Button */}
                  <button 
                    type="submit" 
                    className="form-submit-button"
                    disabled={state.submitting}
                  >
                    {state.submitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>

            {/* Back button */}
            {!state.succeeded && (
              <button onClick={() => navigateToSection(0)} className="back-button contact-back-centered">
                ← Back to Home
              </button>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;